import store from '../../store';

export default async (to, from, next) => {
  // don't go futher if we haven't loaded all the taxons yet
  if (store.state.search.taxons === null) {
    await Promise.all([
      store.dispatch('search/getTaxons'),
      store.dispatch('search/getProperties'),
      store.dispatch('search/getOptions'),
    ]);
  }

  let taxonPermalink = '';

  if (to.name === 'categoryEN' || to.name === 'categoryFR') {
    // %2F -> /
    if (to.path.includes('%2F')) {
      next({ path: `${to.path.replace('%2F', '/')}`, query: { ...to.query } });
      return;
    }
    taxonPermalink = to.params.taxonPermalink;
  }

  if (from.params.taxonPermalink !== taxonPermalink) { store.dispatch('search/setTaxonFromPermalink', taxonPermalink); }

  store.dispatch('search/updateCriteria', to.query);

  store.dispatch('finishLoading');

  next();
};
